<template>
    <div>
        <v-container class="toggle animated" fluid>
            <v-row dense>
                <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    :label="$t('TableHeaders.Search')"
                    density="comfortable"
                    solo
                    hide-details
                    class="rounded-lg"
                    color="white"
                    style="font-family: Saira Condensed, sans-serif;"></v-text-field>
                </v-col>
                <!-- <v-col class="text-right" cols="12" md="8">
                    <v-btn
                    prepend-icon="mdi-plus"
                    class="mt-2 rounded-lg"
                    color="primary"
                    height="40px"
                    elevation="2" style="font-family: Saira Condensed, sans-serif;">
                        Add Points on User
                    </v-btn>
                </v-col> -->
                <v-col cols="12">
                <v-card class="dt-container mt-2">    
                    <v-data-table
                        :mobile="isMobileOrTablet()"
                        :disable-sort="false"
                        :headers="headers"
                        :items="data"
                        :search="search"
                        :loading="loading"
                        class="text-subtitle-1"
                        style="font-family: Saira Condensed, sans-serif;">
                    <template v-slot:loading>
                        <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                    </template>
                    <template v-slot:item.isVerified="{ item }">
                        <v-chip v-if="item.isVerified == true" color="green">
                            <span>✔</span>
                        </v-chip>
                        <v-chip v-else color="red">
                            <span>✘</span>
                        </v-chip>
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                        {{ formatDateTime(item.createdAt) }}
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                            <v-icon 
                            v-if="item.isVerified != true"
                            @click="showVerifyDialog(item)"
                            class="me-2"
                            size="small"
                        >
                            mdi-check-decagram
                        </v-icon>
                    </template>
                    </v-data-table>
                </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="verifyDialog" width="450" persistent>
                <v-card color="primary" rounded="lg" class="pa-2" style="font-family: Saira Condensed, sans-serif;">
                    <v-card-text class="font-weight-bold">
                        {{ $t('AlertDialog.Accounts_Verification.Confirm_Verify') }}
                        <br><br>{{ itemToVerify.title }}
                    </v-card-text>
                    <template v-slot:actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="verifyDialog = false" :disabled="verifyLoading" variant="outlined">
                        {{ $t('Buttons.Cancel') }}
                    </v-btn>
                    <v-btn @click="verifyUser()" :loading="verifyLoading" color="secondary" variant="elevated">
                        {{ $t('Buttons.Confirm') }}
                    </v-btn>
                    </template>
                </v-card>
        </v-dialog>

        <ProductDialog ref="ProductDialog" v-on:refresh="init()"></ProductDialog>
    </div>
    <!-- <CSVDialog ref="CSVDialog" v-on:refresh="init()"></CSVDialog> -->
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import ProductDialog from '../Dialogs/ProductDialog.vue';


export default defineComponent({
    components: {
        ProductDialog
    },
    data(){
        return {
            data: [],
            verifyDialog: false,
            itemToVerify: null,
            verifyLoading: false,
            search: null,
            loading: false,
            headers: [
                { title: 'Discord Username', align: 'start', sortable: true, key: 'username' },
                { title: 'Kick', align: 'start', sortable: true, key: 'kick' },
                { title: 'Stake', align: 'start', sortable: true, key: 'stake' },
                { title: this.$t('TableHeaders.IsVerified'), align: 'start', sortable: true, key: 'isVerified' },
                { title: this.$t('TableHeaders.CreatedAt'), align: 'start', sortable: false, key: 'createdAt' },
                { title: this.$t('TableHeaders.Actions'), align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        init(){
            const token = localStorage.getItem('maherco-admin-accesstoken')
            if(token){
                this.loading = true
                axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/user', { 
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    },
                    params: {
                        page: 1,
                        limit: 10000,
                    }
                }).then((res)=>{
                    if(res){
                        this.data = res.data.users
                        this.loading = false
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("maherco-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
            else{
                localStorage.removeItem("vuex");
                localStorage.removeItem("maherco-admin-accesstoken");
                window.location.reload();
            }
        },
        showVerifyDialog(data){
            this.itemToVerify = data
            this.verifyDialog = true
        },
        verifyUser(){
            const token = localStorage.getItem('maherco-admin-accesstoken')
            axios.put(process.env.VUE_APP_SERVER_URL + `/api/admin/user/${this.itemToVerify._id}/verify`, [], { 
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                }
            }).then((res)=>{
                if(res){
                    this.init()
                    this.verifyLoading = false
                    this.verifyDialog = false
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("maherco-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                }
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        }
    },
    mounted(){
        this.init();
    }
}) 
</script>

<style scoped>

</style>